/* ============================================================
   PODCAST QUESTION MODAL
   Opens the ask-a-question form from the podcast page header.

   Hooks:  [data-podcast-modal]        the modal wrapper
           [data-podcast-modal-open]   trigger, value = modal id
           [data-podcast-modal-close]  overlay / close button
   ============================================================ */
(function () {
  'use strict';

  var FOCUSABLE =
    'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

  var lastTrigger = null;

  // `section { position: relative; z-index: 1 }` in base.css traps the modal
  // in the section's stacking context, underneath the sticky header (z-index
  // 1000). Lift the host section while the modal is open.
  function hostSection(modal) {
    return modal.closest('.podcast-header_section') || modal.parentElement;
  }

  function open(modal, trigger) {
    if (!modal) return;
    lastTrigger = trigger || null;

    var host = hostSection(modal);
    if (host) host.classList.add('podcast-modal-active');

    modal.hidden = false;
    // Next frame so the transition has a starting state to animate from.
    requestAnimationFrame(function () {
      modal.classList.add('is-open');
    });
    document.body.classList.add('podcast-modal-open');

    var first = modal.querySelector(FOCUSABLE);
    if (first) first.focus();
  }

  function close(modal) {
    if (!modal || modal.hidden) return;
    modal.classList.remove('is-open');
    document.body.classList.remove('podcast-modal-open');

    window.setTimeout(function () {
      modal.hidden = true;
      var host = hostSection(modal);
      if (host) host.classList.remove('podcast-modal-active');
    }, 250);

    if (lastTrigger) {
      lastTrigger.focus();
      lastTrigger = null;
    }
  }

  function trapFocus(modal, e) {
    var items = Array.prototype.filter.call(
      modal.querySelectorAll(FOCUSABLE),
      function (el) { return el.offsetParent !== null; }
    );
    if (!items.length) return;

    var first = items[0];
    var last = items[items.length - 1];

    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus();
    }
  }

  /* ── Inline validation, mirroring the contact form section ── */
  function errorFor(input) {
    if (input.type === 'checkbox') return 'This box must be ticked to continue.';
    if (input.type === 'email' && input.value.trim() !== '') return 'Please enter a valid email address.';
    return 'This field is required.';
  }

  function validateField(input) {
    var wrapper = input.closest('.podcast-modal_field, .podcast-modal_consent');
    var errorEl = wrapper ? wrapper.querySelector('.form_error-msg') : null;
    var invalid = input.type === 'checkbox'
      ? !input.checked
      : (input.validity ? !input.validity.valid : input.value.trim() === '');

    if (wrapper) wrapper.classList.toggle('has-error', invalid);
    if (errorEl) {
      errorEl.textContent = invalid ? errorFor(input) : '';
      errorEl.style.display = invalid ? 'block' : 'none';
    }
    return !invalid;
  }

  function bindForm(modal) {
    var form = modal.querySelector('form');
    if (!form) return;

    form.setAttribute('novalidate', '');

    var required = form.querySelectorAll('[required]');

    form.addEventListener('submit', function (e) {
      var firstInvalid = null;

      Array.prototype.forEach.call(required, function (input) {
        if (!validateField(input) && !firstInvalid) firstInvalid = input;
      });

      if (firstInvalid) {
        e.preventDefault();
        firstInvalid.focus();
      }
    });

    Array.prototype.forEach.call(required, function (input) {
      input.addEventListener(input.type === 'checkbox' ? 'change' : 'input', function () {
        validateField(input);
      });
    });
  }

  function init(root) {
    var scope = root || document;

    Array.prototype.forEach.call(scope.querySelectorAll('[data-podcast-modal]'), function (modal) {
      if (modal.dataset.podcastModalReady) return;
      modal.dataset.podcastModalReady = 'true';

      modal.addEventListener('click', function (e) {
        if (e.target.closest('[data-podcast-modal-close]')) close(modal);
      });

      modal.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') close(modal);
        if (e.key === 'Tab') trapFocus(modal, e);
      });

      bindForm(modal);

      // Shopify reloads the page after a contact form post — reopen the
      // modal so the merchant's success message is actually seen.
      if (modal.querySelector('[data-podcast-modal-success]')) open(modal, null);
    });
  }

  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-podcast-modal-open]');
    if (!trigger) return;

    var modal = document.getElementById(trigger.getAttribute('data-podcast-modal-open'));
    if (!modal) return;

    e.preventDefault();
    open(modal, trigger);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  // Theme editor: re-bind when the section is re-rendered.
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
